<script setup lang="ts">
import MetricCard from '@/components/workspace/MetricCard.vue';
import { AlertTriangle, BriefcaseBusiness, FileText, Upload } from 'lucide-vue-next';

interface Props {
    projectCount: number;
    openWorkCount: number;
    agreementCount: number;
    fileCount: number;
}

defineProps<Props>();
const emit = defineEmits<{ projects: []; work: []; contracts: []; files: [] }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <MetricCard interactive density="compact" label="Projects" :value="projectCount" description="Linked client projects" :icon="BriefcaseBusiness" @activate="emit('projects')" />
        <MetricCard interactive density="compact" label="Open work" :value="openWorkCount" description="Tasks and approvals in flight" :icon="AlertTriangle" @activate="emit('work')" />
        <MetricCard interactive density="compact" label="Proposals & contracts" :value="agreementCount" description="Linked proposals and agreements" :icon="FileText" @activate="emit('contracts')" />
        <MetricCard interactive density="compact" label="Files & gallery" :value="fileCount" description="Client and project uploads" :icon="Upload" @activate="emit('files')" />
    </div>
</template>
